(() => {
  if (window.ptCatalogPagination) return;
  window.ptCatalogPagination = true;
  const processed = new WeakSet();
  const cache = new Map();
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const cards = (root) => Array.from(root.querySelectorAll('#product-grid > li[data-pt-product]'));
  const pageUrl = (base, page) => {
    const url = new URL(base);
    url.searchParams.delete('section_id');
    if (page > 1) url.searchParams.set('page', page);
    else url.searchParams.delete('page');
    url.hash = 'product-grid';
    return url;
  };
  async function update(grid) {
    if (processed.has(grid)) return;
    processed.add(grid);
    const nativePages = Number(grid.dataset.ptPages);
    const nativePage = Number(grid.dataset.ptPage);
    const size = Number(grid.dataset.ptPageSize);
    const base = new URL(window.location.href);
    const sectionId = grid.dataset.id;
    const batches = new Array(nativePages);
    batches[nativePage - 1] = cards(grid.parentElement);
    try {
      const pending = [];
      for (let page = 1; page <= nativePages; page++) {
        if (page === nativePage) continue;
        pending.push(page);
      }
      async function worker() {
        while (pending.length && grid.isConnected) {
          const page = pending.shift();
          const url = pageUrl(base, page);
          url.hash = '';
          url.searchParams.set('section_id', sectionId);
          const key = url.href;
          if (!cache.has(key)) {
            cache.set(key, fetch(url).then(async (response) => {
              if (!response.ok) throw new Error('Collection page unavailable');
              return response.text();
            }).catch((error) => { cache.delete(key); throw error; }));
          }
          const doc = parse(await cache.get(key));
          if (!doc.querySelector('#product-grid')) throw new Error('Collection grid unavailable');
          batches[page - 1] = cards(doc);
        }
      }
      await Promise.all(Array.from({ length: Math.min(3, pending.length) }, worker));
      if (!grid.isConnected) return;
      const seen = new Set();
      const all = batches.flat().filter((card) => {
        const id = card.dataset.ptProduct;
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
      });
      const pages = Math.ceil(all.length / size);
      const current = Math.max(1, Math.min(nativePage, pages || 1));
      const visible = all.slice((current - 1) * size, current * size);
      visible.forEach((card, index) => {
        card.querySelectorAll('.scroll-trigger').forEach((node) => node.classList.add('scroll-trigger--cancel'));
        card.classList.add('scroll-trigger--cancel');
        card.style.setProperty('--animation-order', index + 1);
      });
      grid.replaceChildren(...visible);
      const count = all.length === 1 ? grid.dataset.ptCountOne : grid.dataset.ptCountOther.replace('99999', String(all.length));
      document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((node) => { node.textContent = count; });
      const host = grid.parentElement.querySelector('[data-pt-pagination-host]');
      if (!host) return;
      const caret = host.querySelector('.svg-wrapper')?.cloneNode(true);
      const stylesheets = Array.from(host.querySelectorAll('link[rel="stylesheet"]'));
      host.replaceChildren(...stylesheets);
      if (pages < 2) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'pagination-wrapper pt-pagination';
      const nav = document.createElement('nav');
      nav.className = 'pagination';
      nav.setAttribute('aria-label', grid.dataset.ptPaginationLabel);
      const list = document.createElement('ul');
      list.className = 'pagination__list list-unstyled';
      function link(page, text, label, direction) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'pagination__item link';
        a.href = pageUrl(base, page).href;
        a.setAttribute('aria-label', label);
        if (direction) {
          a.classList.add('pagination__item-arrow', `pagination__item--${direction}`, 'motion-reduce');
          if (caret) a.append(caret.cloneNode(true));
          else a.textContent = text;
        } else {
          a.textContent = text;
          if (page === current) {
            a.classList.add('pagination__item--current', 'light');
            a.setAttribute('aria-current', 'page');
          }
        }
        li.append(a);
        list.append(li);
      }
      if (current > 1) link(current - 1, '‹', grid.dataset.ptPreviousLabel, 'next');
      const start = Math.max(2, Math.min(current - 1, pages - 3));
      const end = Math.min(pages - 1, Math.max(current + 1, 4));
      const numbers = new Set([1, pages]);
      for (let page = start; page <= end; page++) numbers.add(page);
      let previous = 0;
      for (const page of Array.from(numbers).sort((a, b) => a - b)) {
        if (page - previous > 1) {
          const li = document.createElement('li');
          const gap = document.createElement('span');
          gap.className = 'pagination__item pt-pagination__gap';
          gap.textContent = '…';
          gap.setAttribute('aria-hidden', 'true');
          li.append(gap);
          list.append(li);
        }
        link(page, String(page), grid.dataset.ptPageLabel.replace('99999', String(page)));
        previous = page;
      }
      if (current < pages) link(current + 1, '›', grid.dataset.ptNextLabel, 'prev');
      nav.append(list);
      wrapper.append(nav);
      host.append(wrapper);
    } catch (error) {
      processed.delete(grid);
      console.warn('Catalog pagination could not refresh', error);
    }
  }
  const scan = () => {
    const grid = document.querySelector('#product-grid[data-pt-pages]');
    if (grid) update(grid);
  };
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
